import * as React from 'react';
import { Fragment, useState } from 'react';

import { MenuItem, Stack, TextField, Typography } from '@mui/material';

import MuiRadioGroup from './MuiRadioGroup';
import { Grid, Box } from '@mui/material';

import Form from 'components/Form';
import { IFormRegister, IFormValues } from 'routes/Main/type';

import SectionTitle from '../components/SectionTitle';
import RowContainer from '../components/RowContainer';
import RowContent from '../components/RowContent';
import RowContentTwo from './components/RowContent';

interface Props extends IFormRegister, IFormValues {
  disabled?: boolean;
  dietList: string[];
  setDietList: (dietList: string[]) => void;
}

const checks = [
  {
    label: '禁食',
    key: 'break_fast.default_diet.checked1',
  },
  {
    label: '小口喝水',
    key: 'break_fast.default_diet.checked2',
  },
  {
    label: '液体饮食',
    key: 'break_fast.default_diet.checked3',
  },
  {
    label: '软食',
    key: 'break_fast.default_diet.checked4',
  },
  {
    label: '常规饮食',
    key: 'break_fast.default_diet.checked5',
  },
  {
    label: '可耐受饮食',
    key: 'break_fast.default_diet.checked6',
  },
  {
    label: '鼻胃管饮食',
    key: 'break_fast.default_diet.checked7',
  },
  {
    label: '全肠外营养',
    key: 'break_fast.default_diet.checked8',
  },
];

const checks2 = [
  {
    label: '糖尿病',
    key: 'break_fast.treatment.checked1',
  },
  {
    label: '肥胖',
    key: 'break_fast.treatment.checked2',
  },
  {
    label: '心血管疾病',
    key: 'break_fast.treatment.checked3',
  },
  {
    label: '消化系统疾病',
    key: 'break_fast.treatment.checked4',
  },
  {
    label: '骨质疏松',
    key: 'break_fast.treatment.checked5',
  },
  {
    label: '便秘',
    key: 'break_fast.treatment.checked6',
  },
  {
    label: '贫血',
    key: 'break_fast.treatment.checked7',
  },
  {
    label: '泌尿系统结石',
    key: 'break_fast.treatment.checked8',
  },
  {
    label: '痛风',
    key: 'break_fast.treatment.checked9',
  },
  {
    label: '放射治疗',
    key: 'break_fast.treatment.checked10',
  },
  {
    label: '胃癌',
    key: 'break_fast.treatment.checked11',
  },
  {
    label: '结直肠癌',
    key: 'break_fast.treatment.checked12',
  },
  {
    label: '肝癌',
    key: 'break_fast.treatment.checked13',
  },
  {
    label: '乳腺癌',
    key: 'break_fast.treatment.checked14',
  },
  {
    label: '肺癌',
    key: 'break_fast.treatment.checked15',
  },
  {
    label: '食道癌',
    key: 'break_fast.treatment.checked16',
  },
  {
    label: '胰腺癌',
    key: 'break_fast.treatment.checked17',
  },
  {
    label: '前列腺癌',
    key: 'break_fast.treatment.checked18',
  },
  {
    label: '甲状腺癌',
    key: 'break_fast.treatment.checked19',
  },
  {
    label: '血液恶性肿瘤',
    key: 'break_fast.treatment.checked20',
  },
  {
    label: '头颈癌',
    key: 'break_fast.treatment.checked21',
  },
  {
    label: '胃食管反流疾病',
    key: 'break_fast.treatment.checked22',
  },
  {
    label: '肾病',
    key: 'break_fast.treatment.checked23',
  },
  {
    label: '肾衰竭',
    key: 'break_fast.treatment.checked24',
  },
];

const DietSelection1 = (props: Props) => {
  const { disabled, register, getValues, setValue, dietList, setDietList } =
    props;

  const 적용급식1 = checks
    .filter((item, i) => getValues(item.key))
    .map(v => v.label);

  const 적용급식2 = checks2
    .filter((item, i) => getValues(item.key))
    .map(v => v.label);

  const 적용급식필터링1 = 적용급식1.join(', ');
  const 적용급식필터링2 = 적용급식2.join(', ');

  const total = 적용급식필터링1 + ' ' + 적용급식필터링2;

  return (
    <>
      <SectionTitle title="早餐" />

      <RowContainer xs={12}>
        <RowContent
          title="卡路里（千卡）"
          titleRatio={1.3}
          childrenRatio={10.7}
        >
          <Stack direction="row" spacing={1}>
            <Form.MuiTextField
              required={false}
              fullWidth
              placeholder="如有必要输入"
              InputProps={{ ...Form.adornment('', 'Kcal') }}
              {...register('break_fast.calorie')}
            />
          </Stack>
        </RowContent>
        <RowContent
          title="早餐"
          titleRatio={10.5}
          childrenRatio={1.5}
        ></RowContent>
        <RowContentTwo title="" titleRatio={0} childrenRatio={12}>
          <Form.MuiTextField
            fullWidth
            InputProps={{ readOnly: true }}
            placeholder={total.length > 0 ? total : '早餐清单'}
            multiline
            minRows={3}
          />
        </RowContentTwo>
      </RowContainer>
      <Box sx={{ width: '95%', margin: '30px auto 0px auto' }}>
        <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>
          基本饮食
        </Typography>

        <Grid container xs={12}>
          {checks.map((v, i) => (
            <Grid item xs={3}>
              <Form.MuiCheckbox
                label={v.label}
                disabled={disabled}
                defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                onChange={(_, checked) => {
                  setValue(v.key, checked);
                  if (checked) setDietList([...dietList, v.label]);
                  else
                    setDietList([
                      ...dietList.filter(value => value !== v.label),
                    ]);
                }}
              />
            </Grid>
          ))}
        </Grid>

        <br />
        <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>
          治疗性饮食
        </Typography>
        <Grid container xs={12}>
          {checks2.map((v, i) => (
            <Grid item xs={3}>
              <Form.MuiCheckbox
                label={v.label}
                disabled={disabled}
                defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                onChange={(_, checked) => {
                  setValue(v.key, checked);
                  if (checked) setDietList([...dietList, v.label]);
                  else
                    setDietList([
                      ...dietList.filter(value => value !== v.label),
                    ]);
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default DietSelection1;
